import React, { useState } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import twoPhones from "../images/two-phones.png";
import useDeviceType from "../../../hooks/useDeviceType";
import useIsMobile from "../../../hooks/useIsMobile";
import clipToSave from "../images/clip-to-save.svg";
import googleMobile from "../images/google-mobile.svg";
import appleMobile from "../images/apple-mobile.svg";
import appleDesktop from "../../../../assets/images/checkout/ocp-app-store-refresh.png";
import googleDesktop from "../../../../assets/images/checkout/ocp-google-store-refresh.png";
import SuccessToast from "../../../ui/molecules/SuccessToast";
import DesktopCodeContainer from "./DesktopCodeContainer";

interface RedeemGiftingProps {
  name?: string;
  amount: string;
  redeemCode: string;
  qrCodeUrl: string;
  appStoreUrl: string;
  playStoreUrl: string;
}

export const RedeemGifting: React.FC<RedeemGiftingProps> = ({
  name,
  amount,
  redeemCode,
  qrCodeUrl,
  appStoreUrl,
  playStoreUrl,
}) => {
  const { isApple } = useDeviceType();
  const isMobile = useIsMobile();
  const [copied, setCopied] = useState(false);

  return (
    <>
      <SuccessToast
        message="Copied to clipboard."
        show={copied}
        setShow={setCopied}
      />
      <div className="grid-container">
        <div className="welcome-container">
          <div className="welcome-bonus-container">
            <div className="welcome-bonus-top">
              <p className="superheader">
                {name
                  ? `${name.toUpperCase()} SENT YOU A GIFT`
                  : "A GIFT FOR YOU"}
              </p>
              <div className="offer-claim-header">Claim your ${amount}</div>
            </div>
            <div className="welcome-bonus-restrictions">
              {!isMobile
                ? "Enter the code below in the inKind app to easily accept your gift!"
                : "Download the inKind app to easily accept your gift!"}
            </div>
            <div className="qr-code-row">
              <div className="your-code">
                <span className="highlight">YOUR CODE</span>
                <span>{redeemCode}</span>
              </div>
              <CopyToClipboard text={redeemCode} onCopy={() => setCopied(true)}>
                <img
                  src={clipToSave}
                  alt="clip to save icon"
                  className="clip-to-save"
                />
              </CopyToClipboard>
            </div>
            <div className="divider-new"></div>
          </div>
          <div className="download-link-container">
            <section className="download-link-body">
              <div className="unlocked-offer-claim-container code-main">
                <div className="download-links-desktop">
                  <div className="download-links-desktop-left">
                    <div>
                      <div className="sub-title">Scan to claim in app</div>
                      <div>
                        Download the inKind app and claim your gift to spend at
                        thousands of top restaurants.
                      </div>
                    </div>
                    <DesktopCodeContainer
                      qrCodeUrl={qrCodeUrl}
                      appStoreUrl={appStoreUrl}
                      playStoreUrl={playStoreUrl}
                      appleDesktop={appleDesktop}
                      googleDesktop={googleDesktop}
                    />
                  </div>
                  <img
                    src={twoPhones}
                    alt="two phones"
                    className="two-phones"
                  />
                </div>
                <div className="download-links-mobile">
                  <div>
                    <div className="sub-title">Download inKind</div>
                    <div>
                      Download the inKind app and claim your gift to spend at
                      thousands of top restaurants.
                    </div>
                  </div>
                  {isApple ? (
                    <a
                      className="download-button"
                      href={appStoreUrl}
                      target="_blank"
                    >
                      <img src={appleMobile} alt="app store" />
                    </a>
                  ) : (
                    <a
                      className="download-button"
                      href={playStoreUrl}
                      target="_blank"
                    >
                      <img src={googleMobile} alt="google play" />
                    </a>
                  )}
                  <img
                    src={twoPhones}
                    alt="two phones"
                    className="two-phones"
                  />
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};
